import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  portfolioList: {
    maxHeight: 350,
    overflow: 'auto'
  },
}))